// REDIRECT URLS
export const LOCALHOST_URL = "http://localhost:3000/terms";
export const DEV_URL = "https://euss-dev.musea2.azure.ext.gm.com/terms";
export const TEST_URL ="https://euss-ui-2-t1-tst.musea2.azure.ext.gm.com/terms";
export const PROD_URL = "https://euss-prod.musea2.azure.ext.gm.com/terms";

// CAPS
export const CAPS_INSTANCE_DEV = "https://custlogin.pp.gm.com/";
export const CAPS_INSTANCE_PROD = "https://custlogin.gm.com/";
export const CAPS_AUTHORITY_DEV ="https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/b2c_1a_seamlessmigration_signuporsignin";
export const CAPS_AUTHORITY_PROD ="https://custlogin.gm.com/gmb2cprod.onmicrosoft.com/b2c_1a_seamlessmigration_signuporsignin";
export const CAPS_APPLICATION_ID_DEV = "16535589-7634-4e3f-82fb-bd963a1e79e1";
export const CAPS_APPLICATION_ID_PROD = "700470b9-2d48-4604-8c47-65549d0e88f0";

//API Endpoint (FUNCTION APP URLs)
export const API_ENDPOINT_DEV ="https://euss-function2-dev.musea2.azure.ext.gm.com";
export const API_ENDPOINT_TEST ="https://euss-function2-dev.musea2.azure.ext.gm.com";
export const API_ENDPOINT_PROD = "https://euss-function2-prod.musea2.azure.ext.gm.com";

// QR Value URLs (WEB APP URLs)
export const QR_VALUE_LOCALHOST = "http://localhost:3000/";
export const QR_VALUE_DEV = "https://euss-ui-dev.musea2.azure.ext.gm.com/";
export const QR_VALUE_TEST = "https://euss-ui-t1-tst.musea2.azure.ext.gm.com/";
export const QR_VALUE_PROD = "https://euss-api-prod.musea2.azure.ext.gm.com/";
